import React, { memo } from 'react';
import { View, StyleSheet } from 'react-native';
import { AnchorRect } from '@/hooks/common/useAnchoredPosition';
import { CreateEventFormData, CreateEventFormErrors } from '@/types/admin/createEvent';
import { DateTimePickerButton } from '@/components';
import { SectionHeader } from '@/components/shared/redesign';

interface DateTimeSectionProps {
  formData: CreateEventFormData;
  errors: CreateEventFormErrors;
  onStartTimePress: (anchor?: AnchorRect) => void;
  onEndTimePress: (anchor?: AnchorRect) => void;
}

export const DateTimeSection = memo<DateTimeSectionProps>(
  ({ formData, errors, onStartTimePress, onEndTimePress }) => {
    return (
      <View style={styles.section}>
        <SectionHeader title="Date & Time" />

        <DateTimePickerButton
          label="Start Time *"
          value={formData.startTime}
          onPress={onStartTimePress}
          error={errors.startTime}
        />

        <DateTimePickerButton
          label="End Time *"
          value={formData.endTime}
          onPress={onEndTimePress}
          error={errors.endTime}
        />
      </View>
    );
  },
);

DateTimeSection.displayName = 'DateTimeSection';

const styles = StyleSheet.create({
  section: {
    marginBottom: 24,
  },
});
